import { SystemText } from '@salesperformanceint/e4shared';
import React from 'react';
import { withRouter } from 'react-router-dom';

export const Panel = ({ colour, icon, message, url, setShow, history }) => {
    const show = Boolean(url) || Boolean(setShow);

    return (
        <div className={colour} onClick={url ? () => history.push(url) : setShow}>
            <div>
                <i className={`fa fa-${icon}`} />
            </div>
            <div>
                {Array.isArray(message) ? (
                    message.map((m, i) => (
                        <span className="mr5" key={`message-${i}`}>
                            {m}
                            <br />
                        </span>
                    ))
                ) : (
                    <span className="mr5">{message}</span>
                )}
                {show && (
                    <span className="no-wrap mr5">
                        [<button className="btn btn-link">{SystemText('General/Controls/Panel/View')}</button>]
                    </span>
                )}
            </div>
        </div>
    );
};

export default withRouter(Panel);
